import type { AxiosRequestConfig } from 'axios';
import { PaginationParams } from '@/shared/api/pagination';
import type {
  EnrichmentItemCreateRequest,
  EnrichmentItemRequest,
} from '@/entities/srm/enrichment';
import type {
  EnrichmentPlanResponse,
  PageEnrichmentPlanResponse,
} from '@/entities/srm/enrichment';
import type { EnrichmentGroupResponse } from '@/entities/srm/enrichment';
import { srmInstance } from '@/shared/api/api-instances/srm/api-instance';
import { ImportEntities } from '@/shared/api/import-contracts';

const baseURL = '/api/srm/v4/';

const defaultOptions = { baseURL };

export class EnrichmentPlansAPI {
  static getEnrichmentItems(
    params: PaginationParams,
    options?: AxiosRequestConfig,
  ) {
    return srmInstance.get<PageEnrichmentPlanResponse>(`/enrichment_plan`, {
      ...options,
      params,
    });
  }

  static getEnrichmentItemByName(
    name: string,
    // params?: PaginationParams,
    options: AxiosRequestConfig = { baseURL: '/api/srm/v3/' },
  ) {
    return srmInstance.get<EnrichmentPlanResponse>(`/enrichment_plan/${name}`, {
      ...defaultOptions,
      ...options,
    });
  }

  static deleteEnrichmentItem(name: string, options?: AxiosRequestConfig) {
    return srmInstance.delete(`/enrichment_plan/${name}`, {
      ...defaultOptions,
      ...options,
    });
  }

  static createEnrichmentItem(
    item: EnrichmentItemCreateRequest,
    options?: AxiosRequestConfig,
  ) {
    return srmInstance.post<EnrichmentPlanResponse | EnrichmentGroupResponse>(
      `/enrichment_plan`,
      item,
      options,
    );
  }

  static saveEnrichmentItem(
    name: string,
    item: EnrichmentItemRequest,
    options?: AxiosRequestConfig,
  ) {
    return srmInstance.put(`/enrichment_plan/${name}`, item, {
      ...defaultOptions,
      ...options,
    });
  }

  static exportEnrichmentPlans(ids: string[], options?: AxiosRequestConfig) {
    return srmInstance.post('/export/enrichment_plans/json', ids, options);
  }

  static importFilePlans(formData: FormData, options?: AxiosRequestConfig) {
    return srmInstance.post<string>(
      '/import/enrichment_plans/json_file',
      formData,
      options,
    );
  }

  static importJSONPlans(
    plans: EnrichmentPlanResponse[],
    options?: AxiosRequestConfig,
  ) {
    return srmInstance.post<string>(
      '/import/enrichment_plans/json',
      plans,
      options,
    );
  }

  static analyzeEntities(
    json: EnrichmentPlanResponse,
    options?: AxiosRequestConfig,
  ) {
    return srmInstance.post('/import/enrichment_plans/analyze', json, {
      ...defaultOptions,
      ...options,
    });
  }

  static executeEntities(data: ImportEntities, options?: AxiosRequestConfig) {
    return srmInstance.post('/import/enrichment_plans/execute', data, {
      ...defaultOptions,
      ...options,
    });
  }

  static validateImport(
    json: { enrichment_plans: EnrichmentPlanResponse[] },
    options?: AxiosRequestConfig,
  ) {
    return srmInstance.post('/import/enrichment_plans/validate', json, {
      ...defaultOptions,
      ...options,
    });
  }
}